import React from 'react';
import { Paper, Stack, Typography } from '@mui/material';

const SummaryCard = ({ label, value }) => (
  <Paper
    variant="outlined"
    sx={{
      p: 2,
      flex: 1,
      borderRadius: 2.5,
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
    }}
  >
    <Typography variant="overline" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="h5" sx={{ fontWeight: 700 }}>
      {value}
    </Typography>
  </Paper>
);

const ReportsSummaryStrip = ({ summary }) => {
  return (
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
      <SummaryCard label="Total Reports" value={summary.total} />
      <SummaryCard label="Active" value={summary.active} />
      <SummaryCard label="Created Last 7 Days" value={summary.recent} />
      <SummaryCard label="Top Scope" value={summary.topScope} />
    </Stack>
  );
};

export default ReportsSummaryStrip;
